import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'

export const SignUpPageStyled = styled.div({
  display: 'grid',
  rowGap: spacing.bigx3,
  boxSizing: 'border-box',
  gridTemplateRows: 'min-content 1fr min-content',
  minHeight: '100%',
  padding: '2.2rem 2rem 2rem',
})

export const Content = styled.div({
  backgroundColor: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.bigx1,
})

export const Footer = styled.div({
  flex: '0 0 100px',
  display: 'flex',
  gap: spacing.sm,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'top',
})
